var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questionnaire-view"},[_c('div',{staticClass:"common-parse-session-card"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.customContent.title))]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('span',{staticClass:"body-content"},[_vm._v(_vm._s(_vm.customContent.text))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04ebba64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/right/chat/QuestionnaireView.vue
// module id = null
// module chunks = 